<template>
  <VRFilterReport v-if="userHasPermission" :useClientLayout="true" />
  <AdminLayout v-else page="VR Filter Report" title="VR Filter Report">
    You need permission to view this page.
  </AdminLayout>
</template>
<script lang="ts" setup>
import VRFilterReport from "../staffadmin/VRFilterReport.vue";
import { PermissionType } from "../../store/generatedFetchClient";
import { useUserStore } from "../../store/userStore";

var userHasPermission = computed(() =>
  useUserStore().hasPermission(PermissionType.ViewVRFilterReport)
);
</script>
